import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';
import { connect } from 'react-redux';

// components
import { FormattedMessage } from 'react-intl';
import { Button } from 'dibs-elements/exports/Button';
import ArrowRight from 'dibs-vg/dist/react/arrow-right';
import makeOfferLauncher from 'dibs-buyer-layout/exports/makeOfferLauncher';

// mutations
import { SharedModifyPortfolioItems } from '../../mutations/SharedModifyPortfolioItems';

// styles
import styles from './PdpSharedButtons.scss';

// helpers
import get from 'lodash.get';
import { trackMakeOfferClick, trackMakeOfferFromEmail } from '../tracking/actionButtonsTracking';
import { intlShape, injectIntl } from 'react-intl';
import { setCartItems } from '../../actions/sharedMobileActions';
import { getQueryParam } from '../../utils/uriUtils';

// constants
const makeOfferCTA = showArrow => (
    <div className={styles.makeOfferButton}>
        <FormattedMessage
            id="PdpSharedMakeOfferButton.makeOfferCta"
            defaultMessage="Make An Offer"
        />
        {showArrow && <ArrowRight className={styles.arrowSVG} />}
    </div>
);

export class PdpSharedMakeOfferButtonComponent extends React.Component {
    constructor(props) {
        super(props);

        this.openModal = this.openModal.bind(this);
    }

    componentDidMount() {
        const queryParams = get(global, 'location.search');
        const modalParam = getQueryParam(queryParams, 'modal');
        const templateParam = getQueryParam(queryParams, 'utm_campaign');

        if (modalParam === 'offer') {
            this.openModal();

            if (templateParam) {
                trackMakeOfferFromEmail({
                    template: templateParam,
                    item: this.props.item,
                });
            }
        }
    }

    openModal() {
        const {
            dispatch,
            userId,
            itemId,
            item,
            relay,
            quantitySelected,
            currency,
            hasPrivateOffer,
        } = this.props;
        trackMakeOfferClick({
            ...item,
            pdpTrackingVpvParams: item.makeOfferVpvParams,
            hasPrivateOffer,
        });

        if (!userId) {
            // If no user, store item - it can be ADDed to cart when user logs in later
            dispatch(setCartItems(itemId));
        } else {
            // ADD item to user's cart
            this.addToCartMutation(itemId);
        }

        makeOfferLauncher({
            itemId,
            currency,
            environment: relay.environment,
            quantitySelected,
        });
    }

    addToCartMutation(itemId) {
        const { relay, userId } = this.props;
        SharedModifyPortfolioItems.commit(relay.environment, {
            action: 'ADD',
            itemId,
            portfolioType: 'CART',
            userId,
        });
    }

    render() {
        const { size, showArrow } = this.props;

        return (
            <Button
                type="secondary"
                className={`${styles.button} ${styles.fullWidth}`}
                dataTn="item-actions-make-offer"
                onClick={this.openModal}
                size={size}
            >
                {makeOfferCTA(size !== 'small' && showArrow)}
            </Button>
        );
    }
}

PdpSharedMakeOfferButtonComponent.defaultProps = {
    size: 'large',
    showArrow: true,
    hasPrivateOffer: false,
};

PdpSharedMakeOfferButtonComponent.propTypes = {
    userId: PropTypes.string,
    itemId: PropTypes.string.isRequired,
    item: PropTypes.object.isRequired,
    dispatch: PropTypes.func,
    intl: intlShape.isRequired,
    currency: PropTypes.string.isRequired,
    relay: PropTypes.object,
    user: PropTypes.object,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    quantitySelected: PropTypes.string,
    showArrow: PropTypes.bool.isRequired,
    hasPrivateOffer: PropTypes.bool,
};

PdpSharedMakeOfferButtonComponent = connect()(injectIntl(PdpSharedMakeOfferButtonComponent));

export const PdpSharedMakeOfferButton = createFragmentContainer(PdpSharedMakeOfferButtonComponent, {
    item: graphql`
        fragment PdpSharedMakeOfferButton_item on Item {
            ...SharedContactDealerWrapper_item
            serviceId
            makeOfferVpvParams: pdpTrackingVpvParams(
                userId: $userId
                excludedPurchaseStatuses: [RET, CUST]
            ) @include(if: $isClient)
            contemporaryTrackingString
            title
            seller {
                serviceId
            }
            pricing {
                totalAmount {
                    amount
                }
            }
            categoryCode
            browseUrl
        }
    `,
    user: graphql`
        fragment PdpSharedMakeOfferButton_user on User {
            ...SharedContactDealerWrapper_user
            profile {
                currency
            }
        }
    `,
});
